/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contacttype1Inputs */

const de__field_contacttype1 = /** @type {(inputs: _Field_Contacttype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktart`)
};

/**

* @param {_Field_Contacttype1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contacttype1 = /** @type {((inputs?: _Field_Contacttype1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contacttype1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contacttype1(inputs)
});
export { _field_contacttype1 as "_field_contactType" }